







































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

import ConfigureContributionsWealthViewModel
  from '@/vue-app/view-models/components/goals-dashboard/create-goal/link-goal/configure-contributions-wealth-view-model';

@Component({
  name: 'StepConfigureContributions',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class StepConfigureContributions extends Vue {
  view_model = Vue.observable(
    new ConfigureContributionsWealthViewModel(this),
  );

  created() {
    this.view_model.initialize();
  }
}
